import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
// Ensure the path is correct; for example, if the file is in src/components/api/repository.js:
import { useNavigate } from "react-router-dom";
import ApiRepository from "./repository";

/**
 * Custom hook to get a memoized instance of the ApiRepository.
 * This provides a centralized way to access all API calls.
 * @returns {ApiRepository} An instance of the ApiRepository class.
 */
export default function useApiRepository() {
    const { loginReducer, persistItemsReducer } = useSelector((state) => state);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    return useMemo(() => 
        new ApiRepository(dispatch, loginReducer, persistItemsReducer, navigate),
        [dispatch, loginReducer, persistItemsReducer, navigate]);
}